import React, { useEffect, useState } from 'react';
import './night-mode.css';

const STORAGE_KEY = 'navoi-etm-theme';

export default function NightModeToggle() {
  const [isDark, setIsDark] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'dark';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    document.documentElement.classList.toggle('navoi-dark-mode', isDark);
    document.documentElement.dataset.theme = isDark ? 'dark' : 'light';
    try {
      localStorage.setItem(STORAGE_KEY, isDark ? 'dark' : 'light');
    } catch {
      // Theme still works for this session if storage is unavailable.
    }
  }, [isDark]);

  return (
    <button
      type="button"
      className={`night-mode-toggle${isDark ? ' is-dark' : ''}`}
      onClick={() => setIsDark((current) => !current)}
      aria-label={isDark ? 'Yorug‘ rejimga o‘tish' : 'Tungi rejimni yoqish'}
      aria-pressed={isDark}
      title={isDark ? 'Light mode' : 'Night mode'}
    >
      <span className="night-mode-toggle-icon" aria-hidden="true">
        {isDark ? '☀' : '☾'}
      </span>
      <span className="night-mode-toggle-label">
        {isDark ? 'Light mode' : 'Night mode'}
      </span>
      <span className="night-mode-toggle-indicator" aria-hidden="true" />
    </button>
  );
}